//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapState, mapMutations } from "vuex";
import { Badge } from "vant";
import SrmCommonUtils from "@/utils/SrmCommonUtils"
import { fetch } from "@/page/index";
import platform from '@/config/platform'
import Websocket from '@/utils/WebSocket'
import systemHook from "@/config/systemHook";
import UserHeader from "../home/UserHeader.vue";
import SelectionModal from "../../components/SelectionModal.vue";
import SrmImGroup from "./SrmImGroup.vue";
import store from '@/common/store/StoreCommon'

export default {
	components: {
        UserHeader,
        SelectionModal,
        SrmImGroup
	},
    data() {
        return {
            operateType: String,
            title: "消息",
            showMessage: false,
            showImGroupModal: false,
            roomUserName: null,
            showIMModal: false, //显示改密模态框
            receiptMsg: [],
            msgData: "",
            userFullName: "",
            currentImRoom: {},
            imRoomList: [],
            onLineStatus: false,
            isOpen: false,
	        fileUploadUrl: "Y" === "Y" ? platform.url.fileServer + "/v2/file/upload" : platform.largeFileHost + "/v1/largeFile/upload",
	        headers: systemHook.getHeaders(),
	        fileIds: "",
            userSelectConf: {
                title: "用户选择",
                findApi: 'baseUsersService_findPagination',
                search: { key: 'userFullName', placeholder: '用户名称'},
                searchParams:{
                    userType: 'INSIDE'
                },
                columns: [
                    { title: '用户名称', key: 'userFullName' },
                    { title: '应用平台', key: 'userType', lookup: {code: "SYS_DUTY_PLATFORM"} }
                ]
            },
	        attachmentConfig: {
		        buttonLabel: " ",
		        buttonType: "text",
		        showBadge: false,
		        showTooltip: false,
		        showType: "formItem",
		        functionList: {
			        upload: {
				        disabled: () => {return false },
			        },
			        download: {
				        disabled: () => {return false },
			        },
			        delete: {
				        show: (row, index) => {return false },
				        disabled: () => {return false }
			        }
		        },
		        largeFileFlag: "N"
	        }
        }
    },
    created() {
        this.operateType = this.$route.params.operateType;
    },
    mounted() {
      this.currentUserInfo = this.$store.state.user.userInfo;
      this.websocketInit()
      store.commit('SET_ROOM_UNREAD_HINTS', false)
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.userInfo
        })
    },
    methods: {
        open(obj) {
            this.isOpen = true
            if (!!!this.onLineStatus) {
                this.websocketInit()
            } else {
                this.showIMModal = true;
                new SrmCommonUtils(this).setModalHCenter()
            }
            this.$emit("refresh-status", this.onLineStatus ? 'Y' : 'N')
        },
        close() {
            this.showIMModal = false;
        },
	    /**
	     * 设置聊天信息显示框滚动条到最底下
	     */
	    setMessageScroll() {
		    // 查询完数据后，把滚动条设置到最底
		    setTimeout(() => {
			    // document.querySelectorAll(".message-list")[0].scrollTop = document.querySelectorAll(".message-list")[0].scrollHeight;
		    }, 1000);
	    },
        websocketInit() {
            Websocket.init(this.currentUserInfo, {appId: "mobileImManage"}, this.receiptSocketCallback, this.openCallback, this.closeCallback);
        },
        /**打开连接回调*/
        openCallback(event) {
            // 重新连接时，连接完成后再打开
            if (!!!this.onLineStatus && !!this.isOpen) {
                this.showIMModal = true;
                // new SrmCommonUtils(this).setModalHCenter()
            }
            this.onLineStatus = true
            // this.$emit("refresh-status", 'Y')
        },
        /**关闭连接回调*/
        closeCallback(event) {
            this.onLineStatus = false
            // this.$emit("refresh-status", 'Y')
        },
        /**设置1-1, 单人 聊天室*/
        setSingleIMRoom({userId, userName }) {
            let _desc = null;
            let _userCnt = 2;
            if (userId === this.currentUserInfo.userId) {
                _desc = data.userFullName;
                _userCnt = 1
            } else {
                _desc = "1-1聊天室"
            }
            this.currentImRoom = {
                desc: _desc,
                notice: null,
                userCount: _userCnt,
                imRoomUserBeanList: [],
                sendUser: {userId: this.currentUserInfo.userId, userName: this.currentUserInfo.userFullName},
                isActive: true
            }
            if (userId !== this.currentUserInfo.userId) {
                let _receiptUser = {
                    userId: userId,
                    userName: userName
                }
                this.currentImRoom.imRoomUserBeanList.push(_receiptUser)
            }
            this.currentImRoom.imRoomUserBeanList.push({
                userId: this.currentUserInfo.userId,
                userName: this.currentUserInfo.userFullName
            })
            this.doCreateImRoom(this.currentImRoom)
        },
        /**选中聊天用户*/
        doSelectionImRoom(imRoom) {
            if (this.imRoomList.length === 0) {
                return;
            }
            // 进行入聊天室，先把路由缓存清除掉
            sessionStorage.removeItem("routeParentParams")
            this.imRoomList.forEach((item) => {
                if (item.roomId === imRoom.roomId) {
                    this.currentImRoom = item
                    this.receiptMsg = []
                    item.isActive = true
                    this.$router.push({
                        name: 'imMessageManage',
                        params: item,
                        query: {}
                    })
                } else {
                    item.isActive = false
                }
            })
            if (this.currentImRoom.unreadCount > 0) {
                this.currentImRoom.unreadCount = 0
                this.$nextTick(() => {
                    this.clearRoomUnread(this.currentImRoom)
                })
            }
        },
        /**清除聊天室未读计数*/
        clearRoomUnread(item) {
            let _imRoomBean = {
                roomId: item.roomId
            }
            let _msg = {msgType: 'CLEAN_UNREAD',
                sendUserId: this.currentUserInfo.userId,
                sendDatetime: window.moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                "imRoomBean": _imRoomBean}
            Websocket.send(_msg)
        },
        /**获取聊天室的聊天内容*/
        listImRoomMsgByRoom(item, pageIndex) {
            let _imRoomBean = {
                roomId: item.roomId,
                imRoomMsgBean: {
                    pageIndex: pageIndex
                }
            }
            let _msg = {msgType: 'SELECT_MSG',
                sendUserId: this.currentUserInfo.userId,
                sendDatetime: window.moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                "imRoomBean": _imRoomBean}
            Websocket.send(_msg)
        },
        /**选择待接收人，创建聊天室*/
        doCreateImRoom(imRoom) {
            let _msg = {
                msgType: "CREATE_ROOM",
                imRoomBean: imRoom
            }
            Websocket.send(_msg)
        },
        /**选择待接收人，创建聊天室*/
        doListOnlineRoom(imRoom) {
            let _msg = {
                msgType: "ONLINE_CHANNEL"
            }
            if (!!imRoom) {
              _msg.imRoomBean = imRoom
            }
            Websocket.send(_msg)
        },
	    /**
	     * 创建群组沟通
	     */
	    groupOnCreateRoom(imRoom){
			this.doCreateImRoom(imRoom)
            this.closeImGroup()
	    },
	    /**
	     * 创建群组沟通
	     */
	    groupOnEditRoom(imRoom){
			this.doListOnlineRoom(imRoom)
	    },
        /**发送消息*/
        sendMsg(msgType) {
            if (!!!this.msgData) {
                this.$Message.error("不能发送空信息")
                return
            }
            this.currentImRoom.imRoomMsgBean = {
                roomId: this.currentImRoom.roomId,
                sendUserId: this.currentUserInfo.userId,
                sendUserName: this.currentUserInfo.userFullName,
                msg: this.msgData
            }

            // 重新生新新的数据，减少每次传输的数据量
            let _imRoomBean = {
                roomId: this.currentImRoom.roomId,
                imRoomUserBeanList: this.currentImRoom.imRoomUserBeanList,
                imRoomMsgBean: {
                    roomId: this.currentImRoom.roomId,
                    sendUserId: this.currentUserInfo.userId,
                    sendUserName: this.currentUserInfo.userFullName,
                    msg: this.msgData
                }
            }
            let _msg = {msgType: msgType,
                sendUserId: this.currentUserInfo.userId,
                sendDatetime: window.moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                "imRoomBean": _imRoomBean}
            Websocket.send(_msg)
            this.msgData = ""
        },
        /**设置当前通讯ROOM信息*/
        activeCurrentIMRoom(roomId) {
            if (this.imRoomList.length === 0) {
                return
            }
            this.doSelectionImRoom({roomId: roomId})
        },
        /**信息接收回调方法*/
        receiptSocketCallback(data) {
            switch (data.msgType) {
                case "CREATE_ROOM":
                    this.doCreateImRoomCallback(data)
                    break;
                case "SEND_MSG":
                    this.doSendMessageCallback(data)
                    break;
                case "ERROR":
                    this.doErrorCallback(data)
                    break;
                case "ONLINE_CHANNEL":
                    this.doInitOnlineRoom(data)
                    break;
                case "SELECT_MSG":
                    this.doSelectRoomMsg(data)
                    break;
                case "REVOCATION_MSG":
                    this.doRevocationMsgCallback(data)
                    break;
                default:
                    break;
            }

        },
        /**创建聊天室回调*/
        doCreateImRoomCallback(imRoomBean) {
            this.currentImRoom = imRoomBean
            let _checkImRoom = false;
            if (this.imRoomList.length > 0) {
                this.imRoomList.forEach((item) => {
                    item.isActive = false;
                    if (item.roomId === imRoomBean.roomId) {
                        item.isActive = true;
                        _checkImRoom = true
                    }
                })
            }
            if (!_checkImRoom || this.imRoomList.length === 0) {
                this.imRoomList.unshift(imRoomBean)
            }
            // this.activeCurrentIMRoom(imRoomBean.roomId)
        },
        /**发送消息回调*/
        doSendMessageCallback(imRoomBean) {
            const _this = this
            let _setInactiveRoomInfo = () => {
              let _inactiveRoom = _this.imRoomList.filter(item => {
                if (item.roomId === imRoomBean.roomId) {
                  return item;
                }
              })
              if (!!!_inactiveRoom || _inactiveRoom.length === 0) {
                 _this.imRoomList.unshift(imRoomBean)
                 return;
              }
              // 设置未读信息
              _inactiveRoom[0].unreadCount = imRoomBean.unreadCount
              if (imRoomBean.unreadCount > 0) {
                store.commit('SET_ROOM_UNREAD_HINTS', true)
              }
            }
            // 设置聊天室未读行数信息
            _setInactiveRoomInfo()
        },
        /**后端返回错误信息*/
        doErrorCallback(imRoomBean) {
            throw Error(imRoomBean.imRoomMsgBean.msg);
        },
        /**连接完成返回数据*/
        doInitOnlineRoom(imRoomList) {
          if (!!!imRoomList) {
              return;
          }
          if (imRoomList.length === 0) {
            return;
          }
          this.imRoomList = imRoomList
          this.currentImRoom = {} //this.imRoomList[0]
	        /*this.imRoomList[0].isActive = true
          this.imRoomList.forEach(item => {
            if (imRoomList.length === 1 && item.roomId === imRoomList[0].roomId) {
					    item.desc = imRoomList[0].desc
            }
				    if (item.unreadCount !== null && item.unreadCount > 0) {
              this.$emit("refresh-status", 'U')
            }
          })*/
        },
        /**撤回消息*/
        doRevocationMsgCallback(imRoomBean) {
            console.log(imRoomBean.imRoomMsgBean, "doRevocationMsgCallback")
        },
        /**查询选中聊天室聊天内容*/
        doSelectRoomMsg(imRoomBeanList) {
            const _this = this
            if (!!!_this.imRoomList || this.imRoomList.length === 0) {
                _this.doInitOnlineRoom(imRoomBeanList);
            } else {
                _this.imRoomList.forEach(item => {
                    if (item.roomId === imRoomBeanList[0].roomId) {
                        if (!!!item.imRoomMsgBeanList) {
                            item.imRoomMsgBeanList = []
                        }
                        item.imRoomMsgBeanList = [
                            ...imRoomBeanList[0].imRoomMsgBeanList,
                            ...item.imRoomMsgBeanList
                        ]
                        _this.receiptMsg = item.imRoomMsgBeanList
                        return
                    }
                })
            }
			this.setMessageScroll()
        },
        /**查询要通讯的用户*/
        userSelectOnChange(data) {
            if (!!data && !!data.userId) {
                this.setSingleIMRoom({userId: data.userId, userName: data.userFullName})
                this.userFullName = ""
                this.receiptMsg = []
            } else {
                this.userFullName = ""
            }
        },
	    /**打开用户选择对话框*/
	    doSearchUser() {
			this.$refs.UserSelectionModalRef.open();
	    },
	    /**打开聊天室信息*/
	    imGroup() {
            this.showImGroupModal = true
	    },
        closeImGroup() {
            this.showImGroupModal = false
	    },
	    /**编辑聊天室*/
	    /*editRoomGroup() {
		    this.$refs.SrmImGroupRef.open(this.currentImRoom);
	    },*/
        /**查询历史聊天信息*/
        listIMMessage() {
            this.receiptMsg = []
        },
	    fileUploadSuccess(fileIds, data) {
			this.fileIds = ""
		    this.currentImRoom.imRoomMsgBean = {
			    roomId: this.currentImRoom.roomId,
			    sendUserId: this.currentUserInfo.userId,
			    sendUserName: this.currentUserInfo.userFullName,
			    msg: "发送文件：" + data[0].originalFileName,
			    fileIds: data[0].id,
			    suffixName: data[0].suffixName
		    }

		    // 重新生新新的数据，减少每次传输的数据量
		    let _imRoomBean = {
			    roomId: this.currentImRoom.roomId,
			    imRoomUserBeanList: this.currentImRoom.imRoomUserBeanList,
			    imRoomMsgBean: {
				    roomId: this.currentImRoom.roomId,
				    sendUserId: this.currentUserInfo.userId,
				    sendUserName: this.currentUserInfo.userFullName,
				    msg: "发送文件：" + data[0].originalFileName,
				    fileIds: data[0].id,
				    suffixName: data[0].suffixName
			    }
		    }
		    let _msg = {msgType: 'SEND_MSG',
			    sendUserId: this.currentUserInfo.userId,
			    sendDatetime: window.moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
			    "imRoomBean": _imRoomBean
			}
		    Websocket.send(_msg)
		    //this.setMessageScroll()
		    // console.log(data, "fileUploadSuccess")
	    },
	    // 监听粘贴事件
	    inputOnPastingEvent(event) {
		    let _value = event.clipboardData.getData('Text')
		    console.log(event.clipboardData.getData('Text'), "inputOnPastingEvent")
		    if(typeof(_value) == 'string') {
			    this.msgData += _value
		    }
		    let _file = null
		    const _items = (event.clipboardData || window.clipboardData).items
		    if(_items.length) {
			    for (let i = 0; i < _items.length; i++) {
				    if (_items[i].type.indexOf('image') !== -1) {
					    _file = _items[i].getAsFile()
					    this.handleChange(_file)
					    break
				    }
			    }
		    }
	    },
	    /**
	     * 粘贴附件上传文件服务器
	     * @param file
	     */
	    handleChange(file) {
		    const _formData = new FormData()
		    _formData.append('files', file)
		    fetch.fileUploadService_imgUpload(_formData).then(res => {
				console.log(res, "fileUploadService_imgUpload")
			    if (!!res.data) {
				    this.fileUploadSuccess(res.data[0].id, res.data)
			    }
		    });
	    }
    }
}



// WEBPACK FOOTER //
// ./src/page/srm/imManage/SrmIMManage.vue